import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';
import $ from 'jquery';

class GetBestSellingProductList extends Event {
    eventName = 'oms_getBestSellingProductList';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override fire success event
     * 
     * @param {*} data data to pass for the event
     * @param {*} options 
     */
    onSuccessEvent(data, options = []) {
        try {

            let response = {
                // "action": (action) ? action : null
                "action": (options['action']) ? options['action'] : null,
                "start": options['start']
            };

            $.extend(response, data);

            let requestId = (options['request_id']) ? options['request_id'] : '';
            this.dispatch(this.eventName + 'Success' + requestId, { "result": response });

        } catch (error) {
            console.log(error);
        }
    }

    /**
     * @override
     * 
     * Event Function for Get Best Sellling Products
     * 
     * @param {string} data.sort_property -  sort property
     * @param {string} data.sort_direction -  sort direction
     * @param {string} data.limit -  limit of response
     * @param {string} data.start -  start of response
     * @param {array} data.filter_groups -  filters of response
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'product_list';
        let start = data.start;
        let locationId = (!data.all_location_data) ? new LocalStorage.CurrentLocation(clientId).getData() : null;

        data.endPoint = application_settings.endPoints.getBestSellingProducts;
        data.multi_call_key = multiCallKey;
        data.data = {
            client_id: clientId,
            location_id: locationId,
            limit: data.limit,
            start: start,
            sort_property: data.sort_property,
            sort_direction: data.sort_direction,
            filter_groups: data.filters,
            order_currency:data.order_currency,
            keyword: data.keyword
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let dataProductAll = new LocalStorage.DataCategoryAll(locationId);
                dataProductAll.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {
                    'action' : action, 
                    'request_id' : requestId, 
                    'start' : start,
                });
            }
        });
    }
}

export default GetBestSellingProductList;